import React, { useState, useEffect } from "react";
import { FaSearch, FaBell, FaBook, FaUserCircle, FaChartLine, FaList, FaCog, FaSignOutAlt, FaUser, FaCogs } from "react-icons/fa";
import { MdLibraryBooks, MdOutlineMenuBook } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import Button from '../../components/ui/Button';
import Card from '../../components/ui/Card';
import Input from '../../components/ui/Input';
import Logo from '../../assets/eBrary_Logo.png';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import EbraryBanner from '../../components/EbraryBanner';
import EbraryCounter from '../../components/EbraryCounter';
import EbrarySubjects from '../../components/EbrarySubjects';

const Dashboard = ({ onSearch, initialQuery }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [notifications, setNotifications] = useState([
    { id: 1, message: "New book added to your course", read: false },
    { id: 2, message: "Your library subscription expires soon", read: false }
  ]);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const unreadCount = notifications.filter((n) => !n.read).length;

  const [username, setUsername] = useState(null); // Store the username
  const [displayname, setDisplayname] = useState(null); // Store the username
  const [accountMenuAnchorEl, setAccountMenuAnchorEl] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [inputValue, setInputValue] = useState(initialQuery || '');
  const navigate = useNavigate();
  const location = useLocation();

    // Function to handle the search action
   // Function to handle the search action
   const handleSearch = () => {
    const query = (inputValue || "").trim();
  
    if (!query) {
      alert("Please enter a search term.");
      return;
    }

    // Navigate to the correct URL
    navigate(`/Textbooks?query=${encodeURIComponent(query)}`, {
      state: { query },
    });
  };
  
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      setUsername(user.username);  // Set username if user is logged in
      setDisplayname(user.displayname);
    }
  }, []);


  const handleClear = () => {
    setInputValue('');
  };

  const handleLogout = () => {
    // Clear the token and user from localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('user');

    // Redirect the user to the login page
    navigate('/');
  };

  return (
    <div className="bg-gray-100 text-gray-900 flex h-screen transition-all duration-300">
      {/* Sidebar */}
      <div className={`fixed sm:relative h-full p-6 transition-transform duration-300 flex flex-col justify-between 
                      ${sidebarOpen ? "w-72" : "w-20"} bg-gradient-to-b from-blue-900 to-blue-950 text-white shadow-lg`}>        
        {sidebarOpen && (
          <div className="flex justify-between items-center mb-6 bg-white p-3 rounded-lg shadow-md">
            <img src={Logo} alt="eBrary Guru Logo" className="h-10" />
            <button onClick={() => setSidebarOpen(!sidebarOpen)}>
              <IoMdClose size={24} className="text-blue-500" />
            </button>
          </div>
        )}
        {!sidebarOpen && (
          <button onClick={() => setSidebarOpen(!sidebarOpen)} className="text-white">
            <FaList size={24} />
          </button>
        )}
        <nav className="space-y-4 flex flex-col items-start">
          <Button variant="ghost" className="flex items-center space-x-3 text-lg">
            <FaChartLine /> {sidebarOpen && <span>My Course</span>}
          </Button>
          <Button variant="ghost" className="flex items-center space-x-3 text-lg">
            <MdLibraryBooks /> {sidebarOpen && <span>My Library</span>}
          </Button>
          <Button variant="ghost" className="flex items-center space-x-3 text-lg">
            <FaBook /> {sidebarOpen && <span>eBrary Collection</span>}
          </Button>
          <Button variant="ghost" className="flex items-center space-x-3 text-lg">
            <MdOutlineMenuBook /> {sidebarOpen && <span>Research Collection</span>}
          </Button>
          <Button variant="ghost" className="flex items-center space-x-3 text-lg">
            <FaCog /> {sidebarOpen && <span>User Management</span>}
          </Button>
          <Button variant="ghost" className="flex items-center space-x-3 text-lg">
            <FaCog /> {sidebarOpen && <span>Library Management</span>}
          </Button>
          <Button variant="ghost" className="flex items-center space-x-3 text-lg">
            <FaCog /> {sidebarOpen && <span>Usage Reports</span>}
          </Button>
        </nav>
      </div>

      <div className="flex-1 flex flex-col p-6 overflow-y-auto bg-gradient-to-br from-gray-50 to-gray-200">
        <div className="flex justify-between items-center relative bg-white p-4 rounded-lg shadow-md">
          <div className="relative w-full max-w-lg">
                          <Input
                            placeholder="Search eBrary.guru..."
                            className="pl-10"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyPress={(e) => {
                              if (e.key === 'Enter') handleSearch();
                            }}
                          />
            <FaSearch className="absolute left-3 top-3 text-gray-500" />
          </div>
          <div className="flex items-center space-x-4 relative">
            <div className="relative">
              <button onClick={() => setNotificationOpen(!notificationOpen)} className="relative">
                <FaBell size={24} />
                {unreadCount > 0 && (
                  <span className="absolute -top-1 -right-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-full">
                    {unreadCount}
                  </span>
                )}
              </button>
              {notificationOpen && (
                <div className="absolute right-0 mt-2 w-64 bg-white border border-gray-300 rounded-lg shadow-lg z-50">
                  <ul className="py-2 text-gray-900">
                    {notifications.length > 0 ? (
                      notifications.map((notif) => (
                        <li key={notif.id} className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                          {notif.message}
                        </li>
                      ))
                    ) : (
                      <li className="px-4 py-2 text-gray-500">No new notifications</li>
                    )}
                  </ul>
                </div>
              )}
            </div>
            <div className="relative">
              <button onClick={() => setProfileMenuOpen(!profileMenuOpen)}>
                <FaUserCircle size={28} />
              </button>
              {profileMenuOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-300 rounded-lg shadow-lg z-50">
                  <ul className="py-2 text-gray-900">
                    <li className="px-4 py-2 hover:bg-gray-100 flex items-center space-x-2 cursor-pointer">
                      <FaUser /> <span>{`Hello, ${displayname}`}</span>
                    </li>
                    <li className="px-4 py-2 hover:bg-gray-100 flex items-center space-x-2 cursor-pointer">
                      <FaCogs /> <span>Settings</span>
                    </li>
                    <li className="px-4 py-2 hover:bg-gray-100 flex items-center space-x-2 cursor-pointer text-red-600">
                      <FaSignOutAlt /> <span onClick={handleLogout}>Logout</span>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
        <h2 className="text-3xl font-semibold mt-8 text-center">Welcome back, {displayname}!</h2>
        <EbraryBanner />
        <EbrarySubjects />

      </div>

    </div>
  );
};

export default Dashboard;